import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    user: null,
    token: null,
    customers: [],
    customers_search: [],
    isLoading: false,
    rend_sel_customer: ``,
    inCart: [],
    rendszam: ``,
    renddatum: null,
    mainPageGrid: 'list'
  },
  getters: {
    user: state => state.user,
    token: state => state.token,
    customers: state => state.customers,
    rend_sel_customer: state => state.rend_sel_customer,
    customers_search: state => state.customers_search,
    isloggedin: state => state.token!==null,
    isLoading: state => state.isLoading,
    inCart: state => state.inCart,
    rendszam: state => state.rendszam,
    renddatum: state => state.renddatum,
    mainPageGrid: state => state.mainPageGrid,
    cartSum: state => state.inCart.reduce((total, current) => total + (~~current.ar * ~~current.db), 0)
  },
  mutations: {
    set_user(state, item) { state.user = item },
    set_token(state, item) { state.token = item },
    logout(state) {
      state.user = null
      state.token = null
      state.customers = []
      state.customers_search = []
      router.replace('/login')
    },
    set_customers(state, item) { state.customers = item },
    set_rend_sel_customer(state, item) {
        state.rend_sel_customer = item
        state.inCart = []
    },
    set_customers_search(state, item) { state.customers_search = item },
    set_loading(state, item) { state.isLoading = item },
    REMOVE_CART(state) { state.inCart = [] },
    REMOVE_FROM_CART(state, index) { state.inCart.splice(index, 1) },
    R_FROM_CART(state, index) {
      if(state.inCart[index].db === 1) {
        state.inCart.splice(index, 1)
      } else {
        state.inCart[index].db = ~~state.inCart[index].db - 1
      }
    },
    P_TO_CART(state, index) {
      state.inCart[index].db = ~~state.inCart[index].db + 1
    },
    ADD_TO_CART(state, item) {
      var found = state.inCart.find(x => x.tszam === item.tszam && x.rendmegj === item.rendmegj && x.ar === item.ar)
      if(found){
        found.db = ~~found.db + ~~item.db
      } else {
        state.inCart.push(item)
      }
    },
    set_rend_szam(state, item) {
      state.rendszam = item
    },
    set_renddatum(state, item) {
      state.renddatum = item
    },
    clear_cart(state) {
      state.inCart = []
      state.rend_sel_customer = ``
      state.rendszam = ``
      state.renddatum = null
    },
    setGrid(state, item) {
      state.mainPageGrid = item
    }
  },
  actions: {
    async setuser({ commit }, item) { commit('set_user', item) },
    async settoken({ commit }, item) { commit('set_token', item) },
    async logout({ commit }) { commit('logout') },
    async setcustomers({ commit }, item) { commit('set_customers', item) },
    async setrendselcustomer({ commit }, item) { 
      if(item&&item.aktiv == 0) {
          if(confirm('Biztos hogy inaktív ügyfélre rögzíted a rendelést?')) {
              commit('set_rend_sel_customer', item)
          }
      } else {
          commit('set_rend_sel_customer', item)
      }
    },
    async setcustomerssearch({ commit }, item) { commit('set_customers_search', item) },
    async setloading({ commit }, item) { commit('set_loading', item) },
    async addToCart({ commit }, item) { commit('ADD_TO_CART', item) },
    async rFromCart({ commit }, index) { commit('R_FROM_CART', index) },
    async pToCart({ commit }, index) { commit('P_TO_CART', index) },
    async removeCart({ commit }) { commit('REMOVE_CART') },
    async removeFromCart({ commit }, index) { commit('REMOVE_FROM_CART', index) },
    async setrendszam({commit}, item) { commit('set_rend_szam', item)},
    async setrenddatum({commit}, item) { commit('set_renddatum', item)},
    async clearCart({commit}) { commit('clear_cart') },
    async setMainPageGrid({commit}, item) { commit('setGrid', item)},
  },
})


// WEBPACK FOOTER //
// ./src/store.js